import styled, { css } from 'styled-components';

import { NextImageWithLoader } from '@/components/NextImageWithLoader';

import { Flex } from '../../../../Flex';
import { Typography } from '../../../../Typography';

export const LinkButtonIcon = styled.div`
  border-radius: 100%;
  overflow: hidden;
  width: 24px;
  height: 24px;
  min-height: 24px;
  position: relative;
  ${({ theme }) => css`
    margin-right: ${theme.spacing(1)};
  `}
`;
export const LinkButtonLabel = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p1};
    line-height: ${theme.fontSizes.p1};
    font-weight: 500;
  `}
`;
export const LinkButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const LinkButtonStyled = styled.div<{
  $isSvgImage?: boolean;
  $selected?: boolean;
}>`
  white-space: nowrap;
  text-decoration: none;
  text-transform: uppercase;
  display: flex;
  cursor: pointer;
  ${({ $isSvgImage, $selected, theme }) => css`
    padding: ${theme.spacing(1, 4)};
    background-color: ${$selected
      ? theme.colors.primaryDark
      : theme.colors.secondaryLightGrey};
    border: none;
    color: ${$selected ? theme.colors.white : theme.colors.primaryDark};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.p1};
    line-height: ${theme.fontSizes.p1};
    font-weight: 500;
    p {
      font-family: ${theme.fontFamilies.italianPlate};
      font-size: ${theme.fontSizes.p1};
      line-height: ${theme.fontSizes.p1};
    }
    &:hover {
      background-color: ${theme.colors.primaryDark};
      color: ${theme.colors.white};

      ${$isSvgImage &&
      css`
        img {
          filter: brightness(100);
        }
      `}
    }
    ${$isSvgImage &&
    $selected &&
    css`
      img {
        filter: brightness(100);
      }
    `}
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  position: relative;
  width: 98px;
  min-width: 98px;
  max-width: 98px;
  cursor: pointer;
  ${({ theme }) => css`
    &:hover {
      p {
        color: ${theme.colors.primary};
      }
    }
  `}
`;
export const ImgBox = styled.div<{ $backgroundColor: string }>`
  border-radius: 100%;
  overflow: hidden;
  width: 64px;
  height: 64px;
  min-height: 64px;
  position: relative;
  ${({ $backgroundColor, theme }) => css`
    background-color: ${$backgroundColor};
    margin-bottom: ${theme.spacing(2)};
    ${theme.media.md.down} {
      font-size: ${theme.fontSizes.p3};
      width: 56px;
      height: 56px;
      min-height: 56px;
      margin-bottom: ${theme.spacing(2.5)};
    }
  `}
`;
export const Label = styled(Flex)`
  text-transform: uppercase;
  text-align: center;

  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.p2};
    line-height: 14px;
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p3};
    }
  `}
`;

export const Img = styled(NextImageWithLoader)`
  object-fit: cover;

  ${({ theme }) => theme.media.md.down} {
    margin-bottom: -2px;
  }
`;
